import { COMPANY } from "@/data/siteContent";

/**
 * 3D-styled brand logo.
 * - Uses multiple drop-shadow filters to fake 3D depth.
 * - Subtle perspective tilt that rights itself on hover.
 * - `contained`: wraps in a white rounded tile (for dark backgrounds).
 */
export default function Logo({
  size = 44,
  contained = false,
  className = "",
  imgClassName = "",
  withHoverTilt = true,
  "data-testid": testId = "brand-logo",
}) {
  const img = (
    <img
      src={COMPANY.logo}
      alt="Ecomold Clean logo"
      data-testid={testId}
      style={{ height: size, width: size }}
      className={`object-contain select-none pointer-events-none ${
        withHoverTilt ? "eco-logo-3d" : ""
      } ${imgClassName}`}
      draggable={false}
    />
  );

  if (contained) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-xl bg-white ring-1 ring-black/5 shadow-sm ${className}`}
        style={{ padding: 4, height: size + 8, width: size + 8 }}
      >
        {img}
      </span>
    );
  }
  return <span className={`inline-flex items-center ${className}`}>{img}</span>;
}
